import { useRef } from "react";
import useOutsideHandler from "../hooks/useOutsideHandler";

export default function OutsideHandler(props) {
    const wrapperRef = useRef(null);
    useOutsideHandler(wrapperRef, props.handleClose);
    return <div ref={wrapperRef}>{props.children}</div>;
  }